import React, {useEffect, useState} from "react";
import {getDocumentLabel, getGreekCurrencyFormat, isEmpty} from "../../../../../_helpers/commonFunctions";
import Alert from "react-bootstrap/Alert";
import {openBuy} from "../../../../../_helpers/tabOpeners";
import {useDispatch, useSelector} from "react-redux";
import {Badge, Button, Col, Modal, Row} from "react-bootstrap";
import moment from "moment/moment";
import axios from "axios";
import {toast} from "react-toastify";
import DateHelper from "../../../../primer/DateHelper/DateHelper";
import DateBox from "../../../../primer/DateBox";
import Input from "../../../../common/Input";
import Pagination from "../../../../primer/Pagination";

const FixedAssetBuysCorrelation = ({fixedAsset, hookCallback, unHookCallback, forAdditionalImprovements = false}) => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);

    const [show, setShow] = useState(false);

    const [pageChanged, setPageChanged] = useState(false);
    const [page, setPage] = useState(1);
    const [requestData, setRequestData] = useState({
        dateFrom: moment(String(company.year), "YYYY").startOf("year").format("DD/MM/YYYY"),
        dateTo: moment(String(company.year), "YYYY").endOf("year").format("DD/MM/YYYY"),
    })
    const [viewData, setViewData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);

    const [showingInfo, setShowingInfo] = useState([]); // Buys that are having their lines shown

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchViewData(true);
        }
    }, [pageChanged])

    const fetchViewData = (fromPagination = true) => {
        const toReq = {
            company: company.id,
            year: company.year,
            section: "Buys",
            page: page,
            perPage: 10,
            loadLines: true,
            ...requestData,
        }
        if (!fromPagination) {
            setPage(1);
            toReq.page = 1;
        }
        axios.get(`${process.env.REACT_APP_API_URL2}/cloud/fetch-doc-cor`, {
            headers: { "Content-Type": "application/json" },
            params: toReq
        }).then((res) => {
            if (res.data.status === "200") {
                setViewData(res.data.data);
                setTotalPages(res.data.totalPages);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleSave = (object, rowNumber) => {
        hookCallback(object, rowNumber);
        setShow(false);
    }

    const handleDehook = () => {
        unHookCallback();
    }

    return (
        <React.Fragment>
            {forAdditionalImprovements ? (
                <React.Fragment>
                    <Button size={"sm"} onClick={() => {
                        setShow(true);
                    }} className={"ml-3"}>Προσθήκη / Βελτίωση από Εγγραφή αγοράς</Button>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    {!isEmpty(fixedAsset.correlatedBuy) ? (
                        <Alert variant={"secondary"}>
                            Συσχετιζόμενο με την αγορά: <strong onClick={() => openBuy(dispatch, TABS_DATA, company.id, fixedAsset.correlatedBuy)} style={{textDecoration: "underline", textDecorationStyle: "dotted", cursor: "pointer"}}>{fixedAsset.correlatedBuyLabel}</strong>,
                            γραμμή: <strong>{fixedAsset.correlatedBuyRowNumber}</strong>
                            <Button size={"sm"} onClick={() => handleDehook()} className={"ml-2"}>Αποσυσχέτιση</Button>
                        </Alert>
                    ) : (
                        <Alert variant={"secondary"}>
                            Υπάρχει η δυνατότητα συσχέτισης γραμμής αγοράς. <Button size={"sm"} onClick={() => setShow(true)} className={"ml-2"}>Συσχέτιση γραμμής αγοράς</Button>
                        </Alert>
                    )}
                </React.Fragment>
            )}

            <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Συσχέτιση Παγίου</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={"text-muted"}><i>Φίλτρα</i></div>
                    <Row>
                        <Col md={3}>
                            <DateHelper
                                dateFromAndToFunction={(from, to) => setRequestData({...requestData, dateFrom: from, dateTo: to})}
                            />
                        </Col>
                        <Col md={2}>
                            <DateBox
                                name={"dateFrom"}
                                label={"Ημερομηνία από"}
                                selected={moment(requestData.dateFrom, "DD/MM/YYYY").isValid() ? moment(requestData.dateFrom, "DD/MM/YYYY").toDate() : null}
                                onChange={(e) => {
                                    if (moment(e).isValid()) {
                                        setRequestData({...requestData, dateFrom: moment(e).format("DD/MM/YYYY")});
                                    } else {
                                        setRequestData({...requestData, dateFrom: moment().format("DD/MM/YYYY")});
                                    }
                                }}
                            />
                        </Col>
                        <Col md={2}>
                            <DateBox
                                name={"dateTo"}
                                label={"Ημερομηνία έως"}
                                selected={moment(requestData.dateTo, "DD/MM/YYYY").isValid() ? moment(requestData.dateTo, "DD/MM/YYYY").toDate() : null}
                                onChange={(e) => {
                                    if (moment(e).isValid()) {
                                        setRequestData({...requestData, dateTo: moment(e).format("DD/MM/YYYY")});
                                    } else {
                                        setRequestData({...requestData, dateTo: moment().format("DD/MM/YYYY")});
                                    }
                                }}
                            />
                        </Col>
                        <Col md={5}>
                            <Input
                                name={"generalFilter"}
                                label={"Φίλτρο"}
                                value={requestData.generalFilter}
                                onChange={(e) => setRequestData({...requestData, generalFilter: e.target.value})}
                            />
                        </Col>
                    </Row>
                    <Row className={"mt-1"}>
                        <Col md={3}>
                            <Input
                                name={"entity"}
                                label={"Οντότητες"}
                                type={"text"}
                                onChange={(e) => setRequestData({...requestData, entity: e.target.value})}
                            />
                        </Col>
                        <Col md={2}>
                            <Input
                                name={"amount_from"}
                                label={"Ποσό από"}
                                type={"number"}
                                onChange={(e) => setRequestData({...requestData, amount_from: e.target.value})}
                            />
                        </Col>
                        <Col md={2}>
                            <Input
                                name={"amount_to"}
                                label={"Ποσό έως"}
                                type={"number"}
                                onChange={(e) => setRequestData({...requestData, amount_to: e.target.value})}
                            />
                        </Col>
                        <Col md={5} className={"d-flex justify-content-end"}>
                            <Button style={{marginTop: "25px"}} onClick={() => fetchViewData(false)}>Εφαρμογή φίλτρων</Button>
                        </Col>
                    </Row>
                    {totalPages > 0 && (
                        <React.Fragment>
                            <div className="d-flex justify-content-end mb-2 mt-2">
                                <Pagination
                                    currentPage={page}
                                    totalPages={totalPages}
                                    handlePageChange={(page) => {
                                        setPage(page);
                                        setPageChanged(true);
                                    }}
                                />
                            </div>
                            {viewData.length > 0 ? (
                                <table className={"simpleClassicTable"} style={{wordBreak: "break-all"}}>
                                    <colgroup>
                                        <col span={1} style={{width: "5%"}}></col>
                                        <col span={1} style={{width: "15%"}}></col>
                                        <col span={1} style={{width: "30%"}}></col>
                                        <col span={1} style={{width: "20%"}}></col>
                                        <col span={1} style={{width: "10%"}}></col>
                                        <col span={1} style={{width: "20%"}}></col>
                                    </colgroup>
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th>Ημερομηνία</th>
                                        <th>Στοιχεία εγγράφου</th>
                                        <th>Οντότητες</th>
                                        <th>Ποσό</th>
                                        <th>Επιλογή</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {viewData.map((row, idx) => (
                                        <React.Fragment>
                                            <tr key={`ertable-${idx}`}>
                                                <td>
                                                    {showingInfo.includes(row._id) ? (
                                                        <Badge bg={"primary"} style={{cursor: "pointer"}} onClick={() => setShowingInfo(showingInfo.filter((el) => el !== row._id))}>-</Badge>
                                                    ) : (
                                                        <Badge bg={"primary"} style={{cursor: "pointer"}} onClick={() => setShowingInfo([...showingInfo, row._id])}>+</Badge>
                                                    )}
                                                </td>
                                                <td>{moment(row["date"]).format("DD/MM/YYYY")}</td>
                                                <td>{getDocumentLabel(row)}</td>
                                                <td>{row["supplierName"]}</td>
                                                <td>{getGreekCurrencyFormat(row["paymentAmount"] || row["sum"] || row["amount"])}</td>
                                                <td></td>
                                            </tr>
                                            {showingInfo.includes(row._id) && (
                                                <React.Fragment>
                                                    {row.products.map((prod, idx2) => (
                                                        <tr key={`ertable-${idx}-${idx2}`} style={{backgroundColor: "lightgray"}}>
                                                            <td colSpan={4}>{prod["code"]} - {prod["name"]}</td>
                                                            <td>{getGreekCurrencyFormat(prod["totalValue"])}</td>
                                                            <td>
                                                                {isEmpty(prod.correlatedFixedAsset) ? (
                                                                    <React.Fragment>
                                                                        {fixedAsset.correlatedBuy !== row._id ? (
                                                                            <Badge bg={"dark"} style={{cursor: "pointer", userSelect: "none"}} onClick={() => handleSave(row, prod.no)}>Επιλογή</Badge>
                                                                        ) : (
                                                                            <Badge bg={"success"} style={{userSelect: "none"}}>Επιλεγμένο</Badge>
                                                                        )}
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <Badge bg={"info"} style={{userSelect: "none"}}>Αφορά άλλο πάγιο</Badge>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </React.Fragment>
                                            )}
                                        </React.Fragment>
                                    ))}
                                    </tbody>
                                </table>
                            ) : (
                                <span>Δεν βρέθηκαν δεδομένα</span>
                            )}
                        </React.Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShow(false)}>
                        Κλείσιμο
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default FixedAssetBuysCorrelation;
